import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { EquipmentDifferences, VesselEquipment } from 'icreate/common/models/device';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VesselEquipmentService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(vesselId): Promise<VesselEquipment[]> {
        return await lastValueFrom(
            this.http.get<VesselEquipment[]>(`${this.domain}/api/vessel-equipment/${vesselId}`, {
                headers: this.headers,
            })
        );
    }

    async updateList(equipment: EquipmentDifferences, vesselId) {
        return lastValueFrom(this.http.put(`${this.domain}/api/vessel-equipment`, { equipment, vesselId }));
    }
}
